import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "table-content-head" }

import TableContentRowComponent from "../../components/sections/TableContentRowComponent.vue";
import { ref } from "vue";
import { ProductGroup } from "../../classes/productGroup";
import { featureIsDiff } from "../../helper/general";

interface Props {
  productGroup: ProductGroup;
  defaultProduct: number;
  highlightDefaultProduct: boolean;
  liability: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TableContentComponent',
  props: {
    productGroup: { default: undefined },
    defaultProduct: { default: undefined },
    highlightDefaultProduct: { type: Boolean, default: false },
    liability: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;

const showAllFields = ref<boolean>(props.productGroup.products.length === 1);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["table-content", { liability: props.liability }])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.productGroup.features, (feature) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: feature.id
      }, [
        (_unref(featureIsDiff)(feature, props.productGroup))
          ? (_openBlock(), _createBlock(TableContentRowComponent, {
              key: 0,
              "product-group": props.productGroup,
              feature: feature,
              "default-product": props.defaultProduct,
              "highlight-default-product": props.highlightDefaultProduct,
              liability: props.liability
            }, null, 8, ["product-group", "feature", "default-product", "highlight-default-product", "liability"]))
          : _createCommentVNode("", true)
      ], 64))
    }), 128)),
    (props.productGroup.products.length > 1)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "table-content-row show-all",
          "data-cy": "show-more",
          tabindex: "0",
          onKeyup: _cache[0] || (_cache[0] = _withKeys(($event: any) => (showAllFields.value = !showAllFields.value), ["enter"])),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (showAllFields.value = !showAllFields.value))
        }, [
          _createElementVNode("div", _hoisted_1, [
            _cache[2] || (_cache[2] = _createElementVNode("span", null, "Gemeinsame Leistungen", -1)),
            _createElementVNode("span", {
              class: _normalizeClass({
            'agila-icon-down': !showAllFields.value,
            'agila-icon-up': showAllFields.value,
          })
            }, null, 2)
          ])
        ], 32))
      : _createCommentVNode("", true),
    (showAllFields.value)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.productGroup.features, (feature) => {
          return (_openBlock(), _createElementBlock("div", {
            key: feature.id
          }, [
            (!_unref(featureIsDiff)(feature, _ctx.productGroup))
              ? (_openBlock(), _createBlock(TableContentRowComponent, {
                  key: 0,
                  "product-group": _ctx.productGroup,
                  feature: feature,
                  "default-product": _ctx.defaultProduct,
                  "highlight-default-product": _ctx.highlightDefaultProduct,
                  liability: props.liability
                }, null, 8, ["product-group", "feature", "default-product", "highlight-default-product", "liability"]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      : _createCommentVNode("", true)
  ], 2))
}
}

})